import { API_PDC_URL_V2 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const activitiesConstants = {
  GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START: "GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START",
  GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS: "GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS",
  GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR: "GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR",

  SET_FULFILMENTS_ACTIVITY_COMPLETED_START: "SET_FULFILMENTS_ACTIVITY_COMPLETED_START",
  SET_FULFILMENTS_ACTIVITY_COMPLETED_SUCCESS: "SET_FULFILMENTS_ACTIVITY_COMPLETED_SUCCESS",
  SET_FULFILMENTS_ACTIVITY_COMPLETED_ERROR: "SET_FULFILMENTS_ACTIVITY_COMPLETED_ERROR",

  SET_FULFILMENT_CLOSED_START: "SET_FULFILMENT_CLOSED_START",
  SET_FULFILMENT_CLOSED_SUCCESS: "SET_FULFILMENT_CLOSED_SUCCESS",
  SET_FULFILMENT_CLOSED_ERROR: "SET_FULFILMENT_CLOSED_ERROR"
};

export function getFulfilmentCustomersActivities(
  auth, fulfilmentId, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START
      });
      let request = {
        method: "GET",
        url: `${API_PDC_URL_V2}/fulfilments/${fulfilmentId}/customers/${itemId}/activities`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function setFulfilmentActivityCompleted(
  auth, fulfilmentId, activityId, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: activitiesConstants.SET_FULFILMENTS_ACTIVITY_COMPLETED_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/fulfilments/activities/complete`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          activityId: activityId,
          fulfilmentId: fulfilmentId,
          customerId: itemId
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: activitiesConstants.SET_FULFILMENTS_ACTIVITY_COMPLETED_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: activitiesConstants.SET_FULFILMENTS_ACTIVITY_COMPLETED_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function setFulfilmentClosed(
  auth, linkId, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: activitiesConstants.SET_FULFILMENT_CLOSED_START
      });
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/links/${linkId}/complete`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {}
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: activitiesConstants.SET_FULFILMENT_CLOSED_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: activitiesConstants.SET_FULFILMENT_CLOSED_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}
